import { SystemFlowSwitch } from '@if/core/types'
import { useAppConfigContext } from '@src/contexts/app-config-context'
import FeatureFlags from '@src/types/FeatureFlags'
import LoanFlowConfig from '@src/types/LoanFlowConfig'
import { useMemo } from 'react'

export function useFeatureFlags(): FeatureFlags {
  const { featureSwitchInfo } = useAppConfigContext()

  return useMemo(() => {
    if (!featureSwitchInfo?.featureSwitches) {
      return new FeatureFlags([])
    }
    return new FeatureFlags(featureSwitchInfo.featureSwitches)
  }, [featureSwitchInfo])
}

export function useSystemFlows() {
  const { systemFlowInfo } = useAppConfigContext()

  return useMemo(() => {
    if (!systemFlowInfo?.systemFlowSwitch) {
      return new LoanFlowConfig({} as SystemFlowSwitch)
    }
    return new LoanFlowConfig(systemFlowInfo.systemFlowSwitch)
  }, [systemFlowInfo])
}
